import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { Authorities } from "@/model/User.model";
import { useUserStore } from "@/stores/UserStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'KrumosMenu',
    setup(__props) {
        const userStore = useUserStore();
        const menuItems = [
            [
                { text: 'Dashboard', icon: 'mdi-view-dashboard', route: '/admin/dashboard' },
                { text: 'Buchungen', icon: 'mdi-cart', route: '/admin/orders' },
                { text: 'Einsatz- & Abholplan', icon: 'mdi-notebook', route: '/admin/resourceBookings' },
                { text: 'Verfügbarkeiten', icon: 'mdi-calendar-check', route: '/admin/availabilities' },
                { text: 'Kundenverwaltung', icon: 'mdi-account', route: '/admin/customers' }
            ],
            [
                { text: 'Leistungsverwaltung', icon: 'mdi-store', route: '/admin/products' },
                { text: 'Locations', icon: 'mdi-map-marker', route: '/admin/locations' },
                { text: 'Produkteigenschaften', icon: 'mdi-shape-outline', route: '/admin/attributes' },
                { text: 'Resourcen', icon: 'mdi-widgets-outline', route: '/admin/resources' },
            ],
            [
                {
                    text: 'Einstellungen', icon: 'mdi-cog', subMenues: [
                        { text: 'Allgemein', route: '/admin/settings/general' },
                        { text: 'Emails', route: '/admin/settings/email' },
                        { text: 'Rechnung', route: '/admin/settings/invoice' },
                        { text: 'Bankkonten', route: '/admin/settings/ledger' },
                        { text: 'Steuern', route: '/admin/settings/tax' },
                        { text: 'Zahlung', route: '/admin/settings/payment' },
                        { text: 'Daten', route: '/admin/settings/data', authority: Authorities.ROLE_OWNER }
                    ]
                },
            ]
        ];
        return (_ctx, _cache) => {
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list_group = _resolveComponent("v-list-group");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_list = _resolveComponent("v-list");
            return (_openBlock(), _createBlock(_component_v_list, null, {
                default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (menuGroup, groupIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: groupIndex }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuGroup, (item, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (item.authority == null || _unref(userStore).hasAuthority(item.authority))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (item.subMenues)
                                                ? (_openBlock(), _createBlock(_component_v_list_group, { key: 0 }, {
                                                    activator: _withCtx(({ props, isOpen }) => [
                                                        _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, {
                                                            class: ["mt-5", {
                                                                    'mb-5': !isOpen
                                                                }],
                                                            color: "white",
                                                            "prepend-icon": item.icon
                                                        }), {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item_title, { class: "font-weight-light" }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(item.text), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1024)
                                                            ]),
                                                            _: 2
                                                        }, 1040, ["class", "prepend-icon"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subMenues, (subMenu, subMenuIndex) => {
                                                            return (_openBlock(), _createElementBlock(_Fragment, { key: subMenuIndex }, [
                                                                (subMenu.authority == null || _unref(userStore).hasAuthority(subMenu.authority))
                                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: 0,
                                                                        value: subMenu,
                                                                        active: subMenu.route === _ctx.$route.path,
                                                                        onClick: ($event) => (_ctx.$router.push(subMenu.route)),
                                                                        color: "blue"
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, { class: "font-weight-light" }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(subMenu.text), 1)
                                                                                ]),
                                                                                _: 2
                                                                            }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["value", "active", "onClick"]))
                                                                    : _createCommentVNode("", true)
                                                            ], 64));
                                                        }), 128))
                                                    ]),
                                                    _: 2
                                                }, 1024))
                                                : (_openBlock(), _createBlock(_component_v_list_item, {
                                                    key: 1,
                                                    class: "mb-5 mt-5",
                                                    active: item.route === _ctx.$route.path,
                                                    value: item,
                                                    color: "blue",
                                                    "prepend-icon": item.icon,
                                                    onClick: ($event) => (_ctx.$router.push(item.route))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item_title, { class: "font-weight-light" }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.text), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["active", "value", "prepend-icon", "onClick"]))
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 128)),
                            _createVNode(_component_v_divider)
                        ], 64));
                    }), 64))
                ]),
                _: 1
            }));
        };
    }
});
